import React, { useContext, useEffect, useState } from "react";
import Listingnavbar from "../components/listingnavbar";
import { Pagination } from "antd";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import AddDoctypeModal from "../modals/addDoctypeModal";
import { getUserDocs } from "../APIs/API";
import { MyContext } from "../MyContext/MyProvider";

const DoctypeListing = () => {
  const navigate = useNavigate();
  const { setIsLoading } = useContext(MyContext);

  const [docs, setDocs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [opengroupModal, setopengroupModal] = React.useState(false);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleData = docs.slice(startIndex, endIndex);
  const showgroupModal = () => {
    setopengroupModal(true);
  };

  useEffect(() => {
    const fetchDocs = async () => {
      setIsLoading(true);
      try {
        const res = await getUserDocs();
        setDocs(res.documents);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDocs();
  }, []);

  const getStatusBgColor = (status) => {
    return status === "Active" ? "#D2F3CF" : "#F5CDCD";
  };
  const getStatusColor = (status) => {
    return status === "Active" ? "#1FC510" : "#DC5050";
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  function itemRender(type) {
    if (type === "prev") {
      return <a>{"<<"} Previous</a>;
    }
    if (type === "next") {
      return <a>Next {">>"}</a>;
    }
    return null;
  }
  return (
    <>
      <Listingnavbar />
      <div className="client-listing-main">
        <h2 className="text-medium-black roboto-family text-center">
          My Documents
        </h2>
        <div className="listing-top-container d-flex space-between">
          <div
            className="back-btn v-center h-center gap-2 cursor-pointer"
            onClick={() => {
              navigate("/settings");
            }}
          >
            <Icon
              icon="ion:chevron-back-outline"
              width={20}
              height={18}
              color="#FFFFFF"
            />
            <label className="large fw-medium text-white roboto-family ">
              Back
            </label>
          </div>
          <div
            className="add-btn v-center h-center cursor-pointer"
            onClick={showgroupModal}
          >
            <Icon
              icon="zondicons:add-outline"
              width={30}
              height={23}
              color="#FFFFFF"
            />
          </div>
        </div>
        <div className="listingclient-table mt-4">
          <table className="m-auto">
            <thead>
              <tr className="send-email-thead ">
                <th>
                  <div className=" px-3">Document Type</div>
                </th>
                <th>Uploaded at</th>
              </tr>
            </thead>
            <tbody>
              {visibleData.map((data, index) => (
                <tr key={index} className="send-email-tbody ">
                  <td className="first-td">
                    <div className=" px-3">{data.file_name}</div>
                  </td>
                  <td>{data.created_at}</td>
                  <td
                    className="last-td "
                    onClick={() => {
                      navigate("/mydocview", {
                        state: { text: data.anonymized_text },
                      });
                    }}
                  >
                    <div className="d-flex gap-2">
                      <Icon
                        icon="teenyicons:eye-outline"
                        width={24}
                        height={20}
                        color="#42425D"
                        className="cursor-pointer"
                      />
                      <label className="large text-dark-green fw-medium text-underline cursor-pointer">
                        View
                      </label>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="listing-bottom h-center">
          <Pagination
            total={docs.length}
            itemRender={itemRender}
            pageSize={itemsPerPage}
            onChange={handlePageChange}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
            itemRenderder={(page, type, originalElement) => {
              if (type === "prev") {
                return <a>Prev</a>;
              }
              if (type === "next") {
                return <a>Next</a>;
              }
              return originalElement;
            }}
          />
        </div>
      </div>
      {/* <AddDoctypeModal
        opengroupModal={opengroupModal}
        setopengroupModal={setopengroupModal}
      /> */}
    </>
  );
};

export default DoctypeListing;
